export default __webpack_public_path__ + "static/fj-df2e4607d0a0f6a3cad41f1362daaf43.svg";